<script setup lang="ts">
  import { ref } from "vue";
  import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
  import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
  import { FileText, Lightbulb, Target, BarChart3 } from "lucide-vue-next";
  import DefaultTab from "./tabs/DefaultTab.vue";
  import LearningsTab from "./tabs/LearningsTab.vue";
  import AdsTab from "./tabs/AdsTab.vue";
  import StatsTab from "./tabs/StatsTab.vue";
  import type { Histo } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    histo: Histo | null;
  }>();

  const isOpen = defineModel<boolean>("open", { default: false });
  const activeTab = ref("default");
</script>

<template>
  <Sheet v-model:open="isOpen">
    <SheetContent
      side="right"
      class="text-13 w-[40vw] sm:max-w-[40vw] p-0 flex flex-col overflow-hidden">
      <SheetHeader class="px-6 pt-4 pr-14 pb-4 shrink-0">
        <SheetTitle class="heading-title">
          {{ histo?.survey_name }}
        </SheetTitle>
        <SheetDescription class="text-sm text-foreground/70">
          {{ histo?.account_name }}
        </SheetDescription>
      </SheetHeader>

      <div
        v-if="histo"
        class="flex-1 overflow-y-auto px-6 pb-6">
        <Tabs
          v-model="activeTab"
          class="w-full">
          <TabsList class="grid w-full grid-cols-4 mb-6">
            <TabsTrigger
              value="default"
              class="text-xs sm:text-sm gap-1">
              <FileText class="h-4 w-4" />
              <span class="hidden sm:inline">General</span>
            </TabsTrigger>
            <TabsTrigger
              value="learnings"
              class="text-xs sm:text-sm gap-1">
              <Lightbulb class="h-4 w-4" />
              <span class="hidden sm:inline">Learnings</span>
            </TabsTrigger>
            <TabsTrigger
              value="ads"
              class="text-xs sm:text-sm gap-1">
              <Target class="h-4 w-4" />
              <span class="hidden sm:inline">Ads</span>
            </TabsTrigger>
            <TabsTrigger
              value="stats"
              class="text-xs sm:text-sm gap-1">
              <BarChart3 class="h-4 w-4" />
              <span class="hidden sm:inline">Drop/SO</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent
            value="default"
            class="mt-0">
            <DefaultTab :histo="histo" />
          </TabsContent>

          <TabsContent
            value="learnings"
            class="mt-0">
            <LearningsTab :histo="histo" />
          </TabsContent>

          <TabsContent
            value="ads"
            class="mt-0">
            <AdsTab :histo="histo" />
          </TabsContent>

          <TabsContent
            value="stats"
            class="mt-0">
            <StatsTab :histo="histo" />
          </TabsContent>
        </Tabs>
      </div>
    </SheetContent>
  </Sheet>
</template>
